<template>
  <div class="form-page-wrapper">
    <div class="top-select-box">
      <el-button type="success" @click="back">返回</el-button>
    </div>
    <div class="title">素材信息</div>
    <el-row :gutter="10" class="info">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">素材编号：</div>
        <div class="info__value">{{ routerParams.oid }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">素材描述：</div>
        <div class="info__value">{{ routerParams.title }}</div>
      </el-col>
      <el-col  class="info__col">
        <div class="info__label">链接：</div>
        <div class="info__value">{{ routerParams.linkid }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="info__col">
        <div class="info__label">素材图片：</div>
        <div class="info__value">
          <el-image :src="routerParams.img" error="-" style="width: 25%"/>
        </div>
      </el-col>

    </el-row>

    <div class="title">链接配置列表</div>
    <div style="display: flex;">
      <div style="flex: 1;" @click="addConfig" class="add-config">新增链接配置</div>
    </div>

    <div class="table-wrapper">
      <el-table
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in columns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          sortable
          :min-width="v.minWidth"
          :key="i"
          align="center">
          <template v-slot="scope">
            <template v-if="v.field === 'dyZlink' || v.field === 'dyDeeplink'">
              <div class="tab-editor">
                <el-tooltip effect="dark" :content="scope.row[v.field]" placement="top-start">
                  <div style="max-width: 500px;">
                    <span @click="handleCopy">{{ scope.row[v.field] }}</span>
                  </div>
                </el-tooltip>
              </div>
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog v-model="dialogStatus" :close-on-click-modal="false" @close="close" :title="'配置'"
               width="1100px"
               append-to-body>
      <el-form :model="form" :rules="rules" hide-required-asterisk ref="form"  label-position="left">
        <el-form-item prop="appId">
          <template v-slot:label>
            <div class="form-item__label">所属应用</div>
          </template>
          <search-cps-app-select style="width: 100%" :checked="false" @changeCpsApp="changeCpsApp($event.appId)"/>
        </el-form-item>
        <el-form-item prop="externalInfo">
          <template v-slot:label>
            <div class="form-item__label">扩展信息</div>
          </template>
          <el-input v-model="form.externalInfo" type="text" placeholder="只允许字母大小写、数字、下划线，长度不超过20"
                    maxlength="20" show-word-limit/>
        </el-form-item>
        <el-form-item prop="dspId">
          <template v-slot:label>
            <div class="form-item__label">链接备注</div>
          </template>
          <el-input v-model="form.remark" type="text" maxlength="100" show-word-limit/>
        </el-form-item>
      </el-form>
      <div style="text-align: right;">
        <el-button @click="close" >取消</el-button>
        <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import initTableMixin from '@/mixins/initTable'
import SearchCpsAppSelect from '@/components/SearchCpsAppSelect/index.vue'
import { createProductLink, saveProductLink } from '@/api/manage/cps/commodity'
import {createLiveLink, saveLiveLink} from '@/api/manage/cps/live'

export default {
  name: 'Place/config',
  components: {
    SearchCpsAppSelect
  },
  mixins: [initTableMixin],
  created () {
    this.routerParams = {
      id: this.$route.query.id,
      oid: this.$route.query.oid,
      linkid: this.$route.query.linkid,
      title: this.$route.query.title,
      img: this.$route.query.img,
      type: this.$route.query.type
    }
    this.tableParams.id = this.routerParams.id
    this.init()
  },
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: {},
      tableData: [],
      routerParams: {
        id: undefined,
        oid: undefined,
        linkid: undefined,
        title: undefined,
        img: undefined,
        type: undefined
      },
      columns: [
        { field: 'id', title: '链接编号' },
        { field: 'appName', title: '应用名称' },
        { field: 'externalInfo', title: '扩展信息' },
        { field: 'dyZlink', title: 'zlink' },
        { field: 'dyDeeplink', title: 'deeplink' },
        { field: 'remark', title: '备注' },
        { field: 'createTime', title: '创建时间' }

      ],
      rules: {
        appId: [{ required: true, message: '请选择所属应用', trigger: 'change' }],
        externalInfo: [{ required: true, message: '请填写扩展信息', trigger: 'blur' }]
      }
    }
  },
  methods: {
    beforeInit () {
      if (this.routerParams.type === 'product') {
        this.tableUrl = '/webCpsProduct/linkInfo'
      } else {
        this.tableUrl = '/webCpsLive/linkInfo'
      }
      return true
    },
    afterInit (res) {
      this.tableData = res.data
    },
    addConfig () {
      this.dialogStatus = true
    },
    changeCpsApp (item) {
      this.form.appId = item
    },
    close () {
      this.form = {}
      this.dialogStatus = false
      this.submitLoading = false
      this.init()
    },
    submit () {
      this.submitLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.routerParams.type === 'product') {
            createProductLink({
              appId: this.form.appId,
              externalInfo: this.form.externalInfo,
              platform: 0,
              shareType: [1, 4],
              productUrl: this.routerParams.linkid
            }).then(res => {
              if (res.code === 200) {
                saveProductLink({
                  id: this.routerParams.id,
                  appId: this.form.appId,
                  remark: this.form.remark,
                  externalInfo: this.form.externalInfo,
                  dyDeeplink: res.data.dyDeeplink,
                  dyZlink: res.data.dyZlink,
                  productUrl: this.routerParams.linkid
                }).then(sres => {
                  if (sres.code === 200) {
                    this.$message.success('新增成功')
                    this.close()
                  } else {
                    this.$message.error(sres.msg)
                  }
                })
              }
            })
          } else {
            createLiveLink({
              appId: this.form.appId,
              externalInfo: this.form.externalInfo,
              platform: 0,
              shareType: [1, 4],
              authorOpenid: this.routerParams.linkid
            }).then(res => {
              if (res.code === 200) {
                saveLiveLink({
                  id: this.routerParams.id,
                  appId: this.form.appId,
                  remark: this.form.remark,
                  externalInfo: this.form.externalInfo,
                  dyDeeplink: res.data.dyDeeplink,
                  dyZlink: res.data.dyZlink,
                  productUrl: this.routerParams.linkid
                }).then(sres => {
                  if (sres.code === 200) {
                    this.$message.success('新增成功')
                    this.close()
                  } else {
                    this.$message.error(sres.msg)
                  }
                })
              }
            })
          }
        } else {
          this.submitLoading = false
        }
      })
    },
    // 点击复制
    handleCopy (e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    },
    back () {
      this.$router.push({
        path: '/cps/manage/place'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-editor {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-form-item {
  display: block;
}

.el-form-item ::v-deep .el-form-item__label {
  float: left;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

.title {
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.add-config {
  margin-top: 10px;
  text-align: center;
  line-height: 45px;
  color: #000000d9;
  border: 1px #ddd dashed;
  cursor: pointer;
}

.item-width {
  width: 50%;
  display: block;
}

.add-config:hover {
  color: #409eff;
  border: 1px #409eff dashed;
}

.form-page-wrapper {
  padding: 20px;
  background: #ffffff;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

::v-deep .el-table__expand-column .cell {
  display: none;
}

.el-form-item ::v-deep .el-form-item__label {
  display: block;
}

.info {
  margin-bottom: 25px;
  color: #000000d9;
  font-size: 14px;
  line-height: 2;
}

.info__col {
  margin-bottom: 10px;
}

.info__label {
  display: inline-block;
}

.info__value {
  display: inline-block;
}

.top-select {
  margin-right: 50px;
  margin-bottom: 10px;
}

.top-select-box {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  float: right;
}
</style>
